import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { parseJwt } from "../../utils/parseJWT";
import { performSessionLogout } from "../../utils/sessionLogout";
import axios from "axios";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  isSuperUserProtected,
  ...rest
}) => {
  const location = useLocation();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          performSessionLogout();
        }
        return Promise.reject(error);
      }
    );

    const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
    if (userInfo && userInfo.token) {
      const decodedJwt = parseJwt(userInfo.token);
      if (decodedJwt && decodedJwt.exp && decodedJwt.exp * 1000 < Date.now()) {
        performSessionLogout();
      }
    }

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
  const is2FAuthenticated = localStorage.getItem("2fauthenticated");

  if (isSuperUserProtected && (!userInfo || !userInfo.roles || !userInfo.roles.includes("SuperUser"))) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  if (isAuthProtected && (!userInfo)) {
    window.location.href = "/home";
    return null;
  }

  if (isAuthProtected && is2FAuthenticated === "false") {
    return <Navigate to="/2fauth" state={{ from: location }} replace />;
  }

  if (Layout) {
    return (
      <Layout>
        <Component />
      </Layout>
    );
  }

  return <Component />;
};

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  isSuperUserProtected: PropTypes.bool,
  component: PropTypes.any,
  layout: PropTypes.any,
};

export default Authmiddleware;
